/**
 * The public addresses of OrderUp's own legal documents — ONE definition for
 * every surface that links them.
 *
 * Before this, the privacy policy was linked from exactly one place (checkout's
 * SMS-consent footnote) as a hardcoded string, and nothing else a guest or an
 * employee touches linked it at all (SOC 2 register R39). Every app now imports
 * these, so a move of the policy is one edit, not a hunt.
 *
 * The pages themselves live in `apps/website` (`LetsOrderUp/order-up-website`),
 * which is why these are absolute `letsorderup.com` URLs.
 */

/** OrderUp's privacy policy (`apps/website/src/app/privacy-policy`). */
export const ORDERUP_PRIVACY_POLICY_URL = "https://letsorderup.com/privacy-policy";

/** OrderUp's terms (`apps/website/src/app/terms-and-conditions`). */
export const ORDERUP_TERMS_URL = "https://letsorderup.com/terms-and-conditions";

/**
 * Where the workforce privacy notice WILL be published.
 *
 * NOT PUBLISHED YET: the notice is a draft awaiting counsel review
 * (`docs/WORKFORCE_PRIVACY_NOTICE.md`, `STATUS: draft`). Nothing may link here
 * unconditionally — the staff portal's link renders only while
 * {@link WORKFORCE_PRIVACY_NOTICE_FLAG} evaluates `true`, and that flag stays
 * off until the page exists on `apps/website`.
 */
export const ORDERUP_WORKFORCE_PRIVACY_NOTICE_URL =
  "https://letsorderup.com/workforce-privacy-notice";

/**
 * The per-tenant initiative flag that shows the workforce privacy notice link
 * in the staff portal. Dark until counsel approves the notice and it is
 * published at {@link ORDERUP_WORKFORCE_PRIVACY_NOTICE_URL}.
 */
export const WORKFORCE_PRIVACY_NOTICE_FLAG = "initiative.workforce_privacy_notice";
